import { Injectable } from '@angular/core';
import { NetworkHelperService } from './network-helper.service';
import { environment } from '../../../environments/environment';
import { Address, Location } from '../../shared/models/google-autocomplete';
import { IBodyFetchCoordinates, IBodyFindLocations } from '../models/location';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private networkHelperService: NetworkHelperService) {}

  findLocations(body: IBodyFindLocations) {
    return this.networkHelperService.post<Address[]>(
      `${environment.apiUrl}/find-locations`,
      body
    );
  }

  fetchCoordinates(body: IBodyFetchCoordinates) {
    return this.networkHelperService.post<Location>(
      `${environment.apiUrl}/fetch-coordinates`,
      body
    );
  }

  fetchZipcode() {
    return this.networkHelperService.get<{ zipCode: string }>(
      `${environment.apiUrl}/fetch-zipcode`,
      {}
    );
  }
}
